// src/utils/clientes.js
export function getClienteInfo(clientes, clienteId) {
  const cliente = clientes.find((c) => c.id === clienteId);
  if (!cliente) return null;

  // Objeto de dirección anidada (si existe)
  const dir = cliente.direccion || {};

  // 1) Campos con fallback: primero nivel raíz, luego .direccion
  const calle      = cliente.calle      || dir.calle      || "";
  const numExt     = cliente.numeroExt  || dir.numeroExt  || "";
  const numInt     = cliente.numeroInt  || dir.numeroInt  || "";
  const colonia    = cliente.colonia    || dir.colonia    || "";
  const ciudad     = (cliente.ciudad    || dir.ciudad    || "").toUpperCase();
  const estado     = (cliente.estado    || dir.estado    || "").toUpperCase();
  const cp         =
    cliente.codigoPostal ||
    cliente.cp ||
    dir.codigoPostal ||
    dir.cp ||
    "";
  const pais = (
    cliente.pais ||
    dir.pais ||
    ""
  ).toUpperCase();

  const correo = cliente.correo || cliente.email || "";
  const tel    = cliente.telefono || "";
  const rfc    = cliente.rfc || "";

  // 2) Líneas que se muestran en la tarjeta
  const linea1 = [
    calle && `${calle}`,
    numExt && `#${numExt}`,
    numInt && `Int. ${numInt}`,
    colonia && `${colonia}`,
  ]
    .filter(Boolean)
    .join(", ");

  const linea2 = [
    ciudad && `${ciudad}`,
    estado && `${estado}`,
    pais && `${pais}`,
    cp && `C.P. ${cp}`,
  ]
    .filter(Boolean)
    .join(", ");

  const contacto = correo || tel ? `${correo}${tel ? ` | ${tel}` : ""}` : "";

  const empresaUpper = (
    cliente.empresa || "UNIFICACION PARA LA AUTOMATIZACION SA DE CV"
  ).toUpperCase();

  return {
    raw: cliente,
    linea1,
    linea2,
    contacto,
    rfc,
    empresaUpper,
  };
}
